import {
  assign,
  get,
  isObject,
  isNumber,
  merge,
  map,
  each,
  template,
  uniq,
} from 'lodash';
import { Money } from '@nsftx/money-js/dist/bundle.umd';
import gravityGateway from '@nsftx/seven-gravity-gateway';
import BarcodeScanPlugin from '@nsftx/seven-gravity-gateway/plugin-barcode-scan';
import { bus, formatter, queryStringParser } from '@/utility';
import { pusher } from '@/plugins';
import { resultsApi } from '@/api';
import store from '@/store';

export default {
  activateTicket() {
    bus.$emit('FocusBetInput');
    this.gateway.sendMessage({
      action: 'Betslip.ActivateTicket',
      data: {
        betslipId: store.getters.config.gateway.slaveId,
        ticketId: store.getters.betslip.tickets[0].id,
      },
    });
  },
  onBetslipReset() {
    if (!store.getters.inputErrorMessage) {
      store.dispatch('clearTicket').then(() => {
        const { ticket } = store.getters;
        bus.$emit('FocusBetInput');
        bus.$emit('ticketChange', ticket);
      });
    }
  },
  setTicketPayment() {
    const betTicket = store.getters.ticket;
    const money = Money.createFromMainUnit(store.getters.totalPayment, store.getters.currency);
    store.dispatch('updateTicket', {
      bets: betTicket.bets,
      payment: money.getAmountAsMainUnit(),
      payin: money.getAmountAsMainUnit(),
      winnings: betTicket.winnings,
    });
    this.payInTicket();
    const errorMessage = store.getters.inputErrorMessage;
    if (!errorMessage) {
      store.dispatch('clearTicket');
    }
  },
  createBetslip() {
    const { wheelTickets } = store.getters;
    const betslip = merge({
      tickets: [
        {
          group: {
            taxesConfig: {
              payin: {
                policy: wheelTickets.ticketPayinTaxPolicy,
              },
              payout: {
                policy: wheelTickets.ticketPayoutTaxPolicy,
              },
            },
          },
        },
      ],
    }, store.getters.betslip);

    this.gateway.sendMessage({
      action: 'Betslip.Create',
      data: {
        betslip,
      },
    });
  },
  focusTicketPayment() {
    this.gateway.sendMessage({
      action: 'FocusNext',
      data: [31],
    });
  },
  loadSettings(message) {
    const { data } = message;
    const betshop = get(data, 'betshop') || {};
    const channel = get(data, 'dp');
    const device = get(data, 'device') || {};
    const user = get(data, 'user') || {};
    const product = get(data, 'product') || {};
    const company = get(data, 'company') || {};
    const currency = get(data, 'currency') || get(company, 'currency') || get(user, 'currency') || {};

    store.dispatch('loadConfig', {
      wheelIdentifier: product.cpvUuid,
      locale: company.locale || user.language,
      app: 'RouletteShop',
    }).then(() => {
      store.dispatch('setPlatform', {
        betshopId: betshop ? betshop.id : null,
        betshopUuid: betshop ? betshop.uuid : null,
        cashRegisterUuid: device ? device.cashRegisterUuid : null,
        channel: this.setChannel(channel),
        companyId: company ? company.id : null,
        companyUuid: company.uuid || company.id || null,
        companyName: company.name || null,
        companyLanguage: company.language,
        currency: isObject(currency) ? currency.symbol : currency,
        deviceId: betshop.device ? betshop.device.deviceId : device.id,
        deviceToken: betshop.device ? betshop.device.token : device.token,
        deviceUuid: device.uuid || null,
        productId: product.cpvUuid,
        productUuid: product.uuid,
        productShortcut: product.shortcut || null,
        productName: product.id || null,
        productTitle: product.translation || null,
      }).then(() => {
        this.updateSettings();
      });
      if (this.gateway) {
        this.createBetslip();
      }
      store.dispatch('setLimits');
      if (store.getters.socketProvider === 'pusher') {
        pusher.init();
      }
    });
  },
  gateway: null,
  init() {
    const self = this;
    const { config } = store.getters;
    const Gateway = gravityGateway.slave;
    const qp = queryStringParser.parse(window.location.search) || {};

    this.gateway = new Gateway({
      slaveId: config.gateway.slaveId,
      allowedOrigins: config.gateway.masterOrigins,
      debug: true,
      data: {},
      plugins: qp.application === 'shop' ? [new BarcodeScanPlugin()] : [],
      eventPropagation: {
        click: true,
        keydown: '*',
      },
      eventListeners: {
        keydown: ['82', '87', '107', '83', '9', '13', '70', '111', '187'],
      },
      load(message) {
        self.loadSettings(message);
      },
    });
  },
  validateBetslip(ticket) {
    let notification = null;
    let valid = true;
    const { limits } = store.getters;

    each(ticket.bets, (bet) => {
      /* eslint-disable */
      if (isNumber(store.getters.balanceAmount) && (ticket.payment > store.getters.balanceAmount)) {
        notification = template(store.getters.translations.invalidBalance)(limits.ticket);
        this.sendNotification(notification);
        valid = false;
      } else if (bet.payment < limits.bet.ticketBetMinPayment) {
        notification = template(store.getters.translations.invalidBetPayment)(limits.bet);
        this.sendNotification(notification);
        valid = false;
      } else if (bet.payment > limits.bet.ticketBetMaxPayment) {
        notification = template(store.getters.translations.invalidBetPayment)(limits.bet);
        this.sendNotification(notification);
        valid = false;
      } else if (ticket.payment < limits.ticket.ticketMinPayment) {
        notification = template(store.getters.translations.invalidTicketPayment)(limits.ticket);
        this.sendNotification(notification);
        valid = false;
      } else if (ticket.payment > limits.ticket.ticketMaxPayment) {
        notification = template(store.getters.translations.invalidTicketPayment)(limits.ticket);
        this.sendNotification(notification);
        valid = false;
      }
    });

    return valid;
  },
  sendNotification(notification) {
    store.dispatch('setErrorMessage', notification);
    store.dispatch('setInfoMessage', {
      message: notification,
      messageType: 'error-style',
      icon: 'n-i-void',
      closeIconActive: false,
      delay: 1500,
    });
    if (this.gateway) {
      this.gateway.sendMessage({
        action: 'Notification:Show',
        data: [{
          message: notification,
          type: 'warning',
          delay: 2000,
          actions: false,
        },
        ],
      });
    }
  },
  onTicketReset() {
    bus.$emit('ticketReset');
    const placedBets = uniq(map(store.getters.placedBets, (item) => item.shortcut));
    if (!placedBets.length) {
      store.dispatch('clearTicket').then(() => {
        bus.$emit('FocusBetInput');
      });
    }
  },
  onBetSelect(message) {
    const { bet } = message.data;
    store.dispatch('updateBet', bet);
    bus.$emit('selectBet', bet);
  },
  onUpdateSelectedBet() {
    bus.$emit('updateSelectedBet');
  },
  onBetRemove() {
    bus.$emit('betRemove');
  },
  onTicketPreprint(message) {
    const { data } = message;
    each(data.responseData.bets, (bet) => {
      /* eslint-disable no-param-reassign */
      bet.betSelection = formatter.numberFormatter(bet.betSelection);
    });
    this.printTicket(data);
  },
  onTicketRebet({ data }) {
    const { ticket } = data;
    store.dispatch('clearTicket');
    if (!store.getters.isTerminal) {
      const bets = store.getters.parseTicketBets(ticket.bets, true);
      store.dispatch('setShopRebetTicket', bets);
      bus.$emit('FocusBetInput');
      bus.$emit('ticketChange', ticket);
    } else {
      bus.$emit('rebetTicket', ticket);
      store.dispatch('setTicketPayment');
      router.push('home').catch((error) => error);
    }
  },
  onWidgetEvent(message) {
    const { data } = message;

    if (data) {
      if (data.shortcut === 'Q' && store.getters.isRetail) {
        this.printResults();
        return;
      }
      if (data.shortcut) {
        bus.$emit('ShortcutClicked', data.shortcut);
      }
    }
  },
  printResults() {
    const { config } = store.getters;
    const { platform } = store.getters;
    const payload = {
      wheel: config.wheel.id,
      wheelIdentifier: config.wheel.wheelAccountId,
      locale: config.locale,
      companyUuid: platform.companyUuid,
      pageSize: 10,
    };

    resultsApi.getResults(payload).then((results) => {
      each(results.rounds, (round) => {
        /* eslint-disable no-param-reassign */
        round.result = formatter.numberFormatter(round.result);
      });
      this.sendPrintTemplate('results', 'rouletteResults', results);
    });
    bus.$emit('FocusBetInput');
  },
  sendPrintTemplate(type, npsJobName, value) {
    this.gateway.sendMessage({
      action: 'Peripherals.Print',
      data: {
        productId: 'SpinAndWin',
        type,
        npsJobName,
        data: value,
        ticketData: value,
      },
    });
  },
  payTicketOverIntegrator() {
    const ticket = assign(store.getters.ticketConfiguration, store.getters.ticket);
    if (ticket.round.id && ticket.round.displayId) {
      if (this.validateBetslip(ticket)) {
        this.gateway.sendMessage({
          action: 'Tickets:Pay',
          data: {
            validateTicket: false,
            ticket,
            ticketFormatted: ticket,
          },
        });
        store.dispatch('setLastPlayedTicket', ticket);
        store.dispatch('clearTicket');
        store.dispatch('setCreationType', 'default');
        bus.$emit('clearChips');
      }
    }
  },
  printTicket(ticket) {
    this.gateway.sendMessage({
      action: 'Tickets.Print',
      data: ticket,
      enforceEvent: true,
    });
  },
  onPayingSentSuccess() {
    bus.$emit('ticketIsResolved');
  },
  onPayingFailed() {
    bus.$emit('ticketIsResolved');
    store.dispatch('clearTicket').then(() => {
      const { ticket } = store.getters;
      bus.$emit('FocusBetInput');
      bus.$emit('ticketChange', ticket);
    });
  },
  setChannel(value) {
    const defaultChannel = 'Shop';

    if (value) {
      switch (value.toUpperCase()) {
        case 'RETAIL':
          return defaultChannel;
        case 'TERMINAL':
          return value;
        case 'WEB':
          return value;
        case 'MOBILE':
          return value;
        default:
          return defaultChannel;
      }
    }

    return defaultChannel;
  },
  setListeners() {
    if (this.gateway) {
      this.gateway.on('Betslip.Reset', this.onBetslipReset.bind(this));
      this.gateway.on('Slave.Shown', this.activateTicket.bind(this));
      this.gateway.on('Tickets.PrePrint', this.onTicketPreprint.bind(this));
      this.gateway.on('Tickets.ReBet', this.onTicketRebet.bind(this));
      this.gateway.on('Tickets.PayingSentSuccess', this.onPayingSentSuccess.bind(this));
      this.gateway.on('Tickets.PayingFailed', this.onPayingFailed.bind(this));
      this.gateway.on('Widget.Event', this.onWidgetEvent.bind(this));;
    }
    bus.$on('payTicket', this.payTicketOverIntegrator.bind(this));
    bus.$on('Slave.Load', this.loadSettings.bind(this));
    bus.$on('ticketUpdate', this.ticketUpdate.bind(this));
    window.addEventListener('keydown', (e) => {
      if (e.key === 'q' && store.getters.isRetail) {
        this.printResults();
      }
    });
  },
  ticketUpdate(data) {
    const statusData = {
      game: 'SpinAndWin',
      message: `ticket:${data.action}Response`,
      ticketData: data,
    };
    if (this.gateway) {
      this.gateway.sendMessage({
        action: statusData.message,
        data: statusData,
        enforceEvent: true,
      });
    }

    if (data && data.action === 'add' && this.gateway && !store.getters.isRetail) {
      this.gateway.sendMessage({
        action: 'Tickets.Resolved',
        data: {
          accepted: true,
          ticket: data,
        }
      });
    }
  },
  updateSettings() {
    if (this.gateway) {
      this.gateway.sendMessage({
        action: 'Slave.Loaded',
        data: store.getters.channelSettings,
      });
    }
  },
};
